module.exports = __webpack_public_path__ + "static/media/espen.f982fafa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/espen.svg
// module id = 295
// module chunks = 0